import React from "react";
import { CollapsePanelProps as AntCollapsePanelProps } from "antd/lib/collapse";
import { Collapse as AntCollapse } from "antd";

const Collapse: React.FC<AntCollapsePanelProps> = (props) => {
  return <AntCollapse.Panel {...props}>{props.children}</AntCollapse.Panel>;
};

export default Collapse;
